var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.wechatCallbackProcessing)?_c('div',{staticClass:"wechat-callback-overlay"},[_c('span',[_vm._v("正在处理微信登录...")])]):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }